import * as React from "react";

const ScheduledIcon = (props: { color?: string; size?: number }): JSX.Element => {
    const size = props.size ?? 14;
    const color = props.color ?? "#767676";
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 0C3.13404 0 0 3.134 0 6.99992C0 10.8658 3.13404 13.9998 7 13.9998C10.866 13.9998 14 10.8658 14 6.99992C14 3.134 10.8661 0 7 0ZM9.09503 9.07824C8.8673 9.30596 8.49802 9.30596 8.2703 9.07824L6.41709 7.22505V4.0857C6.41709 3.76372 6.67817 3.50263 7.00016 3.50263C7.16116 3.50263 7.30693 3.5679 7.41236 3.67334C7.5178 3.77878 7.58324 3.92471 7.58324 4.0857V6.74191L9.09503 8.25368C9.32275 8.4814 9.32275 8.85068 9.09503 9.07824Z"
                fill={color}
            />
        </svg>
    );
};

export default ScheduledIcon;
